import type { CalendarAppointment } from '@cartwheel/api/v1'
import { AppointmentPill } from './appointment-pill'
import { DAYS_OF_WEEK, toDateStr } from './utils'

interface WeekViewProps {
  weekStart: Date
  appointmentsByDate: Record<string, CalendarAppointment[]>
  now: Date
  onAppointmentClick: (appointment: CalendarAppointment) => void
}

export function WeekView({
  weekStart,
  appointmentsByDate,
  now,
  onAppointmentClick,
}: WeekViewProps) {
  const days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(weekStart)
    d.setDate(weekStart.getDate() + i)
    return d
  })
  const todayStr = toDateStr(now)

  return (
    <div className="grid grid-cols-7 border-l border-t border-gray-stroke">
      {days.map((day) => {
        const dateStr = toDateStr(day)
        const dayAppts = appointmentsByDate[dateStr] ?? []
        const isToday = dateStr === todayStr

        return (
          <div key={dateStr} className="border-r border-gray-stroke flex flex-col">
            {/* Day header */}
            <div className="border-b border-gray-stroke bg-gray-50 py-2 text-center">
              <div className="text-xs font-medium text-gray-500">{DAYS_OF_WEEK[day.getDay()]}</div>
              <div
                className={`text-sm font-semibold mt-0.5 mx-auto w-7 h-7 flex items-center justify-center rounded-full ${
                  isToday ? 'bg-forest text-white' : 'text-gray-800'
                }`}
              >
                {day.getDate()}
              </div>
            </div>
            {/* Appointments */}
            <div className="p-1 flex flex-col gap-0.5 min-h-32">
              {dayAppts.map((appt) => (
                <AppointmentPill key={appt.id} appointment={appt} onClick={onAppointmentClick} />
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
